module.exports = __webpack_public_path__ + "img/card-debit.f2d29aa6.svg";